"use client";
import React, { useState } from "react";
import Image from "next/legacy/image";
import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
} from "@vis.gl/react-google-maps";

const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
type GMapProps = {
  point: {
    lat: number;
    lng: number;
  };
  label: string;
  zoom?: number;
  mapContainerClassName?: string;
};

const GMap: React.FC<GMapProps> = ({
  point,
  label,
  zoom,
  mapContainerClassName,
}) => {
  const center = point
    ? point
    : { lat: 17.391314028266446, lng: 78.46295974371516 };
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <div className={mapContainerClassName || "h-full"}>
      <APIProvider apiKey={API_KEY} onLoad={() => setMapLoaded(true)}>
        {mapLoaded ? (
          <Map
            defaultZoom={zoom || (point ? 12 : 8)}
            maxZoom={16}
            minZoom={5}
            defaultCenter={center}
            gestureHandling={"greedy"}
            mapId={"a0623f86aad6e970"}
            streetViewControl={false}
            className="w-full md:max-w-64 h-full rounded-lg"
            fullscreenControl={true}
            style={{ width: "100%", minWidth: 0 }}
            center={center}
          >
            <AdvancedMarker position={point}>
              <Pin>
                <div className="ml-36 w-24 font-bold text-md">{label}</div>
              </Pin>
            </AdvancedMarker>
          </Map>
        ) : (
          <Image
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&zoom=7&size=400x400&key=${API_KEY}&markers=color:red%7C${point.lat},${point.lng}`}
            alt="Map"
            layout="fill"
            objectFit="cover"
            className="rounded-lg"
            priority
          />
        )}
      </APIProvider>
    </div>
  );
};
export default GMap;
